import React from 'react';
import LogRocket from 'logrocket';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { PersistGate } from 'redux-persist/integration/react';
import storeConfig, { history } from './store';
import App from './containers/App/App';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './index.css'
import './theme/variables.scss';

import 'sanitize.css/sanitize.css';

LogRocket.init('vxoeei/zombie-app');

const store = storeConfig();
export const StoreExport = store.store;

const target = document.querySelector('#root');
render(
  <Provider store={store.store}>
    <PersistGate loading={null} persistor={store.persistor}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </PersistGate>
  </Provider>,
  target,
);
